import { Divider } from "@material-ui/core"
import Drawer from "@material-ui/core/Drawer"
import { useScrollWithSections } from "common/bit/scrollSection"
import React from "react"
import ButtonBaseBlank from "reusable/ButtonBaseBlank"
import styled from "styled-components"
import colors from "theme/colors"
import { HEADER_ANIME_M, StyledCol, TypographyRtl } from "theme/shared"

const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    padding-top: ${HEADER_ANIME_M}px;
    padding-bottom: 32px;
    background-color: ${(p) => p.theme.colors.headerColor};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  }
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.4);
  }
  z-index: ${(p) => p.theme.zIndex.appBar - 20} !important;
`
const StyledDrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`
const StyledDivider = styled(Divider)`
  width: 100%;
  background-color: ${(p) => p.theme.colors.darkGrey};
  height: 0.5px;
`
const StyledLinkButton = styled(ButtonBaseBlank)<{ $selected?: boolean }>`
  padding-right: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  p {
    color: ${(p) =>
      p.$selected ? p.theme.colors.white : p.theme.colors.darkGrey};
    font-weight:300;
  }
  &:hover {
    p {
      text-decoration: underline;
    }
  }
`

type CarModelSideDrawerProps = {
  isOpen: boolean
  toggleDrawer: (
    open: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void
}

const CarModelSideDrawer = ({
  isOpen,
  toggleDrawer,
}: CarModelSideDrawerProps) => {
  const { sections } = useScrollWithSections()

  return (
    <StyledDrawer anchor={"top"} open={isOpen} onClose={toggleDrawer(false)}>
      <StyledDrawerWrapper role="presentation" onKeyDown={toggleDrawer(false)}>
        <StyledDivider />
        <StyledCol $gap="20px" $notCenter $fullWidth $mt="20px">
          {sections.map((item, index) => (
            <div key={index}>
              <StyledLinkButton
                onClick={(e) => {
                  item.onClick()
                  toggleDrawer(false)(e)
                }}
                $selected={item.selected}
              >
                <TypographyRtl variant="body1" $color={colors.borderGrey}>
                  {item.title}
                </TypographyRtl>
              </StyledLinkButton>
            </div>
          ))}
        </StyledCol>
      </StyledDrawerWrapper>
    </StyledDrawer>
  )
}

export default CarModelSideDrawer
